import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=191514cd&scoped=true"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=191514cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191514cd",
  null
  
)

export default component.exports